import React from "react";
import './Ratings.css';

export default function Ratings({ onChange, disabled, value, onDisabledClick }) {
    return (
        <div className="rating-wrapper">
            {disabled && <div className="rating-overlay" onClick={onDisabledClick} />}
            <div className={`rating ${disabled ? 'rating-disabled' : ''}`}>
                <input
                    id="star-5"
                    type="radio"
                    name="rating"
                    value="5"
                    onChange={onChange}
                    disabled={disabled}
                    checked={value === 5}
                />
                <label htmlFor="star-5">★</label>
                <input
                    id="star-4"
                    type="radio"
                    name="rating"
                    value="4"
                    onChange={onChange}
                    disabled={disabled}
                    checked={value === 4}
                />
                <label htmlFor="star-4">★</label>
                <input
                    id="star-3"
                    type="radio"
                    name="rating"
                    value="3"
                    onChange={onChange}
                    disabled={disabled}
                    checked={value === 3}
                />
                <label htmlFor="star-3">★</label>
                <input
                    id="star-2"
                    type="radio"
                    name="rating"
                    value="2"
                    onChange={onChange}
                    disabled={disabled}
                    checked={value === 2}
                />
                <label htmlFor="star-2">★</label>
                <input
                    id="star-1"
                    type="radio"
                    name="rating"
                    value="1"
                    onChange={onChange}
                    disabled={disabled}
                    checked={value === 1}
                />
                <label htmlFor="star-1">★</label>
            </div>
        </div>
    );
}